import React from 'react';
import { CheckCircle2, ArrowRight } from 'lucide-react';

interface AccountSuccessProps {
    onContinue: () => void;
}

const AccountSuccess: React.FC<AccountSuccessProps> = ({ onContinue }) => {
    return (
        <div className="min-h-screen bg-[#F8FAFC] flex flex-col items-center justify-center p-6 animate-fadeIn">
            <div className="bg-white rounded-[2rem] shadow-xl p-8 max-w-md w-full text-center relative overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-emerald-400 to-emerald-600"></div>

                <div className="w-20 h-20 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-6 text-emerald-500 shadow-sm border border-emerald-100 animate-scaleIn">
                    <CheckCircle2 size={40} />
                </div>

                <h1 className="text-xl font-black text-slate-900 tracking-tight leading-tight mb-2">
                    Account Succesvol Aangemaakt!
                </h1>
                <p className="text-slate-500 font-medium text-sm mb-8 leading-relaxed">
                    Je account is gereed en je organisatie is ingericht. Je kunt nu direct aan de slag met het beheren van vacatures en kandidaten.
                </p>

                <button
                    onClick={onContinue}
                    className="w-full bg-slate-900 text-white py-4 rounded-xl font-black text-xs uppercase tracking-widest shadow-lg hover:bg-black transition-all flex items-center justify-center gap-2 group active:scale-[0.98]"
                >
                    Ga naar Dashboard <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                </button>
            </div>

            <p className="mt-8 text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                © Werftools Platform
            </p>
        </div>
    );
};

export default AccountSuccess;
